import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedIncomeOfferEntityNormalized } from '../../../../../../../../../store/product/types';
import { FixedIncomeAssetProvider } from '../../../../../contexts/products/FixedIncome';
import { ItemDetails } from '../Details';

import { FixedIncomeListItemDesktop } from './desktop';
import { FixedIncomeListItemMobile } from './mobile';
import { FixedIncomeListItemTablet } from './tablet';

export namespace FixedIncomeListItemTypes {
  export interface Props {
    offer: FixedIncomeOfferEntityNormalized;
  }
}

export const FixedIncomeListItem: React.FC<FixedIncomeListItemTypes.Props> = ({ offer }) => {
  const fixedIncomeListItem = useBreakpointValue({
    base: <FixedIncomeListItemMobile offer={offer} />,
    sm: <FixedIncomeListItemTablet offer={offer} />,
    lg: <FixedIncomeListItemDesktop offer={offer} />,
  });

  return (
    <FixedIncomeAssetProvider>
      <ItemDetails />
      {fixedIncomeListItem}
    </FixedIncomeAssetProvider>
  );
};
